import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  history: Identifiable<Project>[];
  retrieveProjectHistory(
    project: Boundaries["retrieveProjectHistory"]["request"],
  ): void;
}

function useRetrieveProjectHistory(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isProjectHistoryRetrievalRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isProjectHistoryRetrievalRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isProjectHistoryRetrievalRequestFailure,
    ),
    history: useSelector(selector.getProjectHistory),
    retrieveProjectHistory: core.retrieveProjectHistory,
  };
}

export { useRetrieveProjectHistory };
